import { Controller } from '@hotwired/stimulus'
import { updateTotalPrice } from '../putup/price-updater'

/**
 * Handles value-added options (splice free, heat treating) for product put-ups
 * 
 * This controller manages the interaction between value-added checkboxes and price calculations.
 * Previously handled via event delegation in product-selection-controller, this has been 
 * refactored to follow Stimulus best practices with dedicated controller responsibility.
 * 
 * Targets:
 *   - checkbox: Each value-added checkbox option
 * 
 * Values:
 *   - box: The box number for this put-up instance (e.g., "1", "2")
 * 
 * Actions:
 *   - toggle: Triggered on checkbox change to recalculate pricing
 * 
 * Usage in ERB:
 *   <div data-controller="value-added" data-value-added-box-value="1">
 *     <input type="checkbox" data-value-added-target="checkbox" 
 *            data-action="change->value-added#toggle" value="10" />
 *   </div>
 */
export default class extends Controller {
  static targets = ['checkbox']
  static values = {
    box: String
  }

  connect() {
    // Initialize price calculation on connect
    this.updatePrice()
  }

  /**
   * Handles checkbox changes and updates the total price
   */
  toggle(event) {
    this.updatePrice()
  }

  /**
   * Calculates the total price modifier from checked options
   * @returns {number} Total modifier percentage (100 = no change, 110 = 10% increase)
   */
  getPriceModifier() {
    let modifier = 100
    
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        modifier += parseFloat(checkbox.value)
      }
    })
    
    return modifier
  }

  /**
   * Updates the total price display
   */
  updatePrice() {
    if (!this.hasBoxValue) {
      console.warn('Value-added controller missing box value')
      return
    }
    
    updateTotalPrice(this.boxValue, this.getPriceModifier.bind(this))
  }
}
